export const isAudioNode = (t) => {
    if (typeof t === 'object' && t !== null) {
        return 'connect' in t && 'disconnect' in t;
    }
    return false;
};
export const isAudioParam = (t) => {
    if (typeof t === 'object' && t !== null) {
        return 'setValueAtTime' in t;
    }
    return false;
};
export const isAudioNodeInit = (t) => {
    if (typeof t === 'object' && t !== null) {
        return 'audioNode' in t && 'create' in t && 'release' in t;
    }
    return false;
};
export const isAnalyzerNodeInit = (t) => {
    if (isAudioNodeInit(t) && t.audioNode) {
        return 'getFloatTimeDomainData' in t.audioNode;
    }
    return false;
};
//# sourceMappingURL=typeGuards.js.map